/* eslint-disable import/extensions */
/* eslint-disable prettier/prettier */
/* eslint-disable no-underscore-dangle */
/* eslint-disable class-methods-use-this */
/* eslint-disable import/prefer-default-export */
// import sensors from '../../assets/js/sensorsdata.es6.min.js'

export default class Sensors {
  protected EnableTrack: boolean

  protected EnableConsole: boolean

  public IsLogin: boolean

  public IsNew: boolean

  private _sensors: any

  private sensor_init(): any {
    // window.sensors.init({
    //   server_url: 'https://unicorn.bloomchic.com/sa?project=default',
    //   show_log: false,
    //   heatmap: {
    //     clickmap: 'default',
    //     scroll_notice_map: 'default',
    //   },
    //   is_track_single_page: true,
    //   use_client_time: true,
    //   send_type: 'beacon',
    //   is_track_device_id: true,
    //   preset_properties: {
    //     latest_utm: true,
    //     latest_traffic_source_type: true,
    //     latest_search_keyword: true,
    //     latest_referrer: true,
    //     latest_referrer_host: true,
    //     latest_landing_page: true,
    //     url: true,
    //     title: true,
    //   },
    // })
    window.sensors.registerPage({
      web_platform_type:
        window.innerWidth >= 768
          ? 'PC_Web'
          : 'Mobile_Web' /* app Platform_type */,
      web_language: navigator.language,
      referrer_url: localStorage.getItem('sensor-referrer'),
      web_is_login: this.IsLogin,
      is_new: this.IsNew,
    })
    window.sensors.quick('useModulePlugin', 'SiteLinker', {
      linker: [
        { part_url: 'shop.bloomchic.com', after_hash: false },
        { part_url: 'bloomchic.com', after_hash: false },
        { part_url: 'dev-shop.bloomchic.com', after_hash: false },
      ],
    })
    // if (typeof window !== 'undefined') window.sensors = sensors
    return window.sensors
  }

  private _abtest: any

  constructor(
    isLoign: boolean,
    isNew: boolean,
    enableTrack: boolean = true,
    enableConsole: boolean = false
  ) {
    this.EnableTrack = enableTrack
    this.EnableConsole = enableConsole
    this.IsLogin = isLoign
    this.IsNew = isNew
    this._sensors = this.sensor_init()
  }

  public track(event: string, data: {}): void {
    if (this.EnableConsole) {
      console.log(event, data)
    }
    if (this.EnableTrack) {
      this._sensors.track(event, data)
    }
  }

  public autoTrack(): void {
    this._sensors.quick('autoTrack')
  }

  public abtest(testName: string, callback: (result: string) => void): void {
    this._abtest.asyncFetchABTest({
      param_name: testName,
      value_type: 'String',
      callback(result: string) {
        callback(result)
      },
    })
  }
}
